export const cardsOptions = [ 
  { value: 'Cartão Débito', label: 'Cartão Débito', color: '#00B8D9', isFixed: true },
  { value: 'Cartão Crédito', label: 'Cartão Crédito', color: '#0052CC'},
  { value: 'Vale', label: 'Vale', color: '#5243AA' },
];